import { ref, computed } from 'vue'

export interface UserContract {
  isTermsAccepted: boolean
  isMarketingAllowed: boolean
}

export const useMemberConsent = () => {
  const userContract = ref<UserContract>({
    isTermsAccepted: true,
    isMarketingAllowed: true,
  })

  const isConsentValid = computed(() => {
    return userContract.value.isTermsAccepted && userContract.value.isMarketingAllowed
  })

  const createConfirmHandler = (callback: (contract: UserContract) => void) => {
    return () => {
      if (!isConsentValid.value) return

      const param = {
        isTermsAccepted: userContract.value.isTermsAccepted,
        isMarketingAllowed: userContract.value.isMarketingAllowed,
      }
      callback(param)
    }
  }

  return {
    userContract,
    isConsentValid,
    createConfirmHandler,
  }
}
